// @ts-strict-ignore
import {createElem} from 'common/util/dom';

// Parse JSON without throwing - returns null on malformed input or null/empty
// string. Used by the external-widget modules to read persisted state out of
// localStorage where a corrupted value should degrade silently to "no state".
export function gracefulJsonParse<T>(json: string | null): T | null {
  try {
    if (json) {
      return JSON.parse(json) as T;
    }
  } catch {
    // ignore - corrupted localStorage value
  }
  return null;
}

// Even though zendesk and insided emit loaded events, there's a chance that the iframe is not visible on the page
// Therefore we use a mutation observer to wait for the iframe to attach to dom.
export async function injectCssIntoIframeWhenAttached(iframeSel: string, css: string) {
  try {
    const body = document.querySelector(`body`);
    const iframe = (await waitForElementInParentMutationObserver(iframeSel, body)) as HTMLIFrameElement;
    const styleOverride = createElem(`style`, {type: `text/css`}, [css]);
    const head = iframe.contentDocument.querySelector(`head`);
    head.appendChild(styleOverride);
  } catch (error) {
    throw new Error(`Failed to inject css into ${iframeSel}: ${error}`, {
      cause: error,
    });
  }
}

function waitForElementInParentMutationObserver(selector: string, parentElement: HTMLElement): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => {
      const element: HTMLIFrameElement = parentElement.querySelector(selector);
      if (element) {
        observer.disconnect();
        resolve(element);
      }
    });

    observer.observe(parentElement, {subtree: false, childList: true});

    // reject after 5 seconds
    setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Condition was not met after 10 seconds.`));
    }, 10000);
  });
}
